module.exports = __webpack_public_path__ + "img/warning.ca705d47.svg";